import type { BadgeTone } from '../components/Badge';
import type { PaymentLedgerEntryDto } from '../api';

export const PAYMENT_STATUS_TONE: Record<string, BadgeTone> = {
    Confirmed: 'success',
    Paid: 'success',
    Unconfirmed: 'warning',
    Sending: 'info',
    Declined: 'error',
    Unknown: 'warning',
    NotPaid: 'neutral',
    Skipped: 'neutral',
    Recorded: 'neutral',
};

export const PAYMENT_STATUSES = ['Confirmed', 'Unconfirmed', 'Sending', 'Paid', 'Declined', 'Unknown', 'NotPaid', 'Skipped'] as const;
export const PAYMENT_SOURCES = ['Received', 'Manual', 'Scheduled', 'AnkaufPayout', 'Refund', 'Redirect'] as const;

export const isBalanceChange = (entry: PaymentLedgerEntryDto) => entry.kind === 'BalanceChange';

export const isTransfer = (entry: PaymentLedgerEntryDto) => isBalanceChange(entry) && entry.explainedByKind === 'BalanceChange';

/** Names a balance change: either half of a bank transfer, or a change no payment explains. */
export function balanceChangeLabelKey(entry: PaymentLedgerEntryDto): string {
    if (isTransfer(entry)) {
        const towardBank = entry.account === 'Bank' ? entry.direction === 'Incoming' : entry.direction === 'Outgoing';
        return towardBank ? 'PAYMENTS_TRANSFER_TO_BANK' : 'PAYMENTS_TRANSFER_FROM_BANK';
    }
    return entry.account === 'Bank' ? 'PAYMENTS_BANK_CHANGE' : 'PAYMENTS_CASH_CHANGE_UNMATCHED';
}

export const signedAmount = (entry: PaymentLedgerEntryDto) => entry.direction === 'Outgoing' ? -entry.amount : entry.amount;

export function entryIcon(entry: PaymentLedgerEntryDto): string {
    if (isTransfer(entry)) return 'fa-right-left';
    if (isBalanceChange(entry)) return entry.account === 'Bank' ? 'fa-building-columns' : 'fa-wallet';
    return entry.direction === 'Incoming' ? 'fa-arrow-down' : 'fa-arrow-up';
}

/** The sellbot record a payment belongs to, when it has a page of its own. */
export function referenceHref(entry: PaymentLedgerEntryDto): string | null {
    if (!entry.referenceId) return null;
    if (entry.source === 'Scheduled') return '/payments/scheduled';
    if (entry.source === 'Received' || entry.source === 'Refund' || entry.source === 'AnkaufPayout') return `/sellbot/transactions/${entry.referenceId}`;
    return null;
}
